// src/pages/GeneralGoods.js
import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import emailjs from '@emailjs/browser';

// --- Modal Form Component ---
const PurchaseModal = ({ item, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '', phone: '', email: '', location: '', address: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setFormData({...formData, [e.target.name]: e.target.value});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      // 1. Save to Firebase
      await addDoc(collection(db, "general_goods_requests"), {
        ...formData,
        itemName: item.name,
        itemId: item.id,
        itemPrice: item.price,
        itemCurrency: item.currency || '$',
        submittedAt: new Date(),
        status: 'Pending'
      });
      
      // 2. Send Email via EmailJS
      // Updated keys to match template
      const emailParams = {
          type: "General Goods Order",
          fullName: formData.fullName,
          email: formData.email, // Added email field to match template
          phone: formData.phone,
          itemName: item.name,
          offerAmount: `${item.currency || '$'}${item.price}`, // Using offerAmount as price for consistency
          message: `Location: ${formData.location}, Address: ${formData.address}`,
          carName: "N/A",
          annualIncome: "N/A"
      };

      await emailjs.send(
          'service_nkj2h8t', 
          'template_lih1iy7', 
          emailParams, 
          'MpvXLl-LNdIwPQyBf'
      );

      alert("Request sent! We will contact you shortly.");
      onClose();
    } catch (error) {
      console.error("Error sending request:", error);
      alert("Error sending request. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      background: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
    }}>
      <div style={{
        background: 'white', padding: '30px', borderRadius: '8px', width: '90%', maxWidth: '500px', position: 'relative'
      }}>
        <button onClick={onClose} style={{
          position: 'absolute', top: '10px', right: '15px', background: 'transparent', border: 'none', fontSize: '1.5rem', cursor: 'pointer'
        }}>×</button>
        
        <h3 style={{marginBottom: '20px', color: '#051337'}}>Request to Buy: {item.name}</h3>
        
        <form onSubmit={handleSubmit}>
          <div style={{marginBottom: '15px'}}>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Full Name</label>
            <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} required style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} />
          </div>
          {/* Added Email Input for consistency */}
          <div style={{marginBottom: '15px'}}>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Email Address</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} />
          </div>
          <div style={{marginBottom: '15px'}}>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Phone Number</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} />
          </div>
          <div style={{marginBottom: '15px'}}>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Location (City/Region)</label>
            <input type="text" name="location" value={formData.location} onChange={handleChange} required style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}} />
          </div>
          <div style={{marginBottom: '20px'}}>
            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Delivery Address</label>
            <textarea name="address" value={formData.address} onChange={handleChange} required rows="3" style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}}></textarea>
          </div>
          
          <button type="submit" className="btn btn-primary" style={{width: '100%'}} disabled={submitting}>
            {submitting ? 'Sending...' : 'Submit Request'}
          </button>
        </form>
      </div>
    </div>
  );
};

// --- Item Card Component ---
const GoodCard = ({ item, onBuyClick }) => {
  const isSold = item.status === 'Sold Out';
  const currencySymbol = item.currency || '$';
  const countryFlag = item.country || '';

  return (
    <div style={{
        border: isSold ? '2px solid red' : '1px solid #ddd',
        borderRadius: '8px',
        overflow: 'hidden',
        background: 'white',
        position: 'relative',
        opacity: isSold ? 0.8 : 1
    }}>
      <div style={{position: 'relative'}}>
        <img src={item.image} alt={item.name} style={{width: '100%', height: '200px', objectFit: 'cover'}} />
        
        {/* Status Badge */}
        <span style={{
            position:'absolute', top:'10px', left:'10px', 
            background: isSold ? 'red' : 'var(--accent-blue)', 
            color:'white', padding:'4px 8px', fontSize:'0.8rem', borderRadius:'4px',
            zIndex: 2,
            animation: isSold ? 'blink 2s infinite' : 'none'
        }}>
          {isSold ? 'SOLD OUT' : item.status}
        </span>

         {/* Country Availability Badge */}
         {countryFlag && (
          <div style={{
            position: 'absolute', top: '10px', right: '10px',
            background: 'rgba(255, 255, 255, 0.95)',
            padding: '4px 8px', borderRadius: '4px', fontSize: '0.85rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            fontWeight: 'bold', color: '#051337',
            zIndex: 2
          }}>
            Available in: {countryFlag}
          </div>
        )}
      </div>

      <div style={{padding: '15px'}}>
        <h3 style={{fontSize: '1.2rem'}}>{item.name}</h3>
        <p style={{color: '#666', fontSize: '0.9rem', marginBottom: '5px'}}>{item.category}</p>
        <p style={{color: '#555', fontSize: '0.95rem', height: '40px', overflow: 'hidden'}}>{item.description}</p>
        
        <h4 style={{color: 'var(--primary-dark)', fontSize: '1.4rem', marginTop: '10px'}}>
            {currencySymbol}{item.price.toLocaleString()}
        </h4>
        
        <div style={{marginTop: '15px'}}>
            <button 
                onClick={() => onBuyClick(item)}
                className="btn btn-primary" 
                style={{width: '100%', opacity: isSold ? 0.5 : 1, cursor: isSold ? 'not-allowed' : 'pointer'}} 
                disabled={isSold}
            >
                {isSold ? 'Sold Out' : 'Contact to Buy'}
            </button>
        </div>
      </div>
      <style>{`@keyframes blink { 50% { opacity: 0.5; } }`}</style>
    </div>
  );
};

const GeneralGoods = () => {
  const [goods, setGoods] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Initialize state from localStorage if available, otherwise default to empty string
  const [category, setCategory] = useState(() => {
      return localStorage.getItem('generalGoodsActiveTab') || '';
  });
  
  const [selectedItem, setSelectedItem] = useState(null); 

  // Save to localStorage whenever category changes
  useEffect(() => {
      localStorage.setItem('generalGoodsActiveTab', category);
  }, [category]);

  useEffect(() => {
    const fetchGoods = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "general_goods"));
        const goodsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setGoods(goodsData);
      } catch (error) {
        console.error("Error fetching goods:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGoods();
  }, []);

  const filteredGoods = category 
    ? goods.filter(g => g.category === category) 
    : goods;

  const CATEGORIES = [
    "Furniture", 
    "Electronics", 
    "Home and Kitchen Appliances", 
    "Vehicle Parts", 
    "Musical Instruments",
    "Merchandise"
  ];

  return (
    <div className="container" style={{padding: '40px 20px'}}>
      <h1 style={{marginBottom: '20px', textAlign: 'center'}}>General Goods & Merchandise</h1>
      
      {/* Category Filter */}
      <div style={{display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '40px', flexWrap: 'wrap'}}>
        <button 
            onClick={() => setCategory('')} 
            className={`btn ${category === '' ? 'btn-primary' : 'btn-outline'}`}
        >
            All Items
        </button>
        {CATEGORIES.map(cat => (
            <button 
                key={cat} 
                onClick={() => setCategory(cat)} 
                className={`btn ${category === cat ? 'btn-primary' : 'btn-outline'}`}
            >
                {cat}
            </button>
        ))}
      </div>

      {loading ? (
        <div style={{textAlign: 'center'}}>Loading items...</div>
      ) : (
        <div style={{
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', 
            gap: '30px'
        }}>
            {filteredGoods.length > 0 ? (
                filteredGoods.map(item => (
                    <GoodCard 
                        key={item.id} 
                        item={item} 
                        onBuyClick={(item) => setSelectedItem(item)} 
                    />
                ))
            ) : (
                <div style={{gridColumn: '1/-1', textAlign: 'center'}}>No items found in this category.</div>
            )}
        </div>
      )}

      {selectedItem && (
        <PurchaseModal 
            item={selectedItem} 
            onClose={() => setSelectedItem(null)} 
        />
      )}
    </div>
  );
};

export default GeneralGoods;